import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import { DateTime } from 'luxon';
import React, { useEffect, useMemo } from 'react';
import { getLatestActivityTime, jwtCookieName, TOKEN_EXP_DATETIME } from 'types/accessControl/AccessControlConstants';
import { decodeOurJWT } from '../decodeOurJWT';

export const ActivityWarningTracker: React.FC = () => {
  const currentCookie = Cookies.get(jwtCookieName);
  const decodedCookie = useMemo(() => (currentCookie ? decodeOurJWT(currentCookie) : null), [currentCookie]);
  useEffect(() => {
    if (!decodedCookie) {
      datadogRum.addError('Activity Warning Modal Showing Sees No Cookie!', {
        currentTime: DateTime.now().toISO(),
        lastActivityTime: getLatestActivityTime().toISO(),
      });
      return;
    }
    datadogRum.addAction('Activity Warning Modal Shown', {
      currentTime: DateTime.now().toISO(),
      lastActivityTime: getLatestActivityTime().toISO(),
      cookieExpiration: new Date(decodedCookie.exp * TOKEN_EXP_DATETIME).toISOString(),
    });
    return () => {
      if (!decodedCookie) {
        datadogRum.addError('Activity Warning Modal Exit Sees No Cookie!', {
          currentTime: DateTime.now().toISO(),
          lastActivityTime: getLatestActivityTime().toISO(),
        });
        return;
      }
      datadogRum.addAction('Activity Warning Modal Hidden', {
        currentTime: DateTime.now().toISO(),
        lastActivityTime: getLatestActivityTime().toISO(),
        cookieExpiration: new Date(decodedCookie.exp * TOKEN_EXP_DATETIME).toISOString(),
      });
    };
  }, [decodedCookie]);
  return null;
};
